import React from 'react';
import ProductCard from 'components/product-card';

import './style.css';

const productsData = [
  {
    id: 'emissions',
    pathname: '/products/emissions',
    name: 'Emissions',
    description: 'Monthly, worldwide emissions at 1-km resolution',
    icon: 'icon-emissions',
  },
  {
    id: 'forecast',
    pathname: '/products/forecast-system',
    name: 'Forecast',
    description: 'World-class hourly forecast, 3 days in advance.',
    icon: 'icon-forecast',
  },
  {
    id: 'retina',
    pathname: '/products/retina/',
    name: 'Retina',
    description: 'Near-real-time monitoring and 3-day forecast, at street-level resolution',
    icon: 'icon-retina',
  },
  {
    id: 'tools',
    pathname: '/products/tools',
    name: 'ATMO-Plan',
    description: 'ATMO-Plan supports urban air quality plans and designing Low Emisson Zones.',
    icon: 'icon-tools',
  },
];

const ProductsList = () => (
  <div className="c-products-list">
    <div className="container">
      <div className="row -equal-height">
        {productsData.map(productData => (
          <div key={productData.id} className="col-md-6 col-sm-12">
            <div className="item">
              <ProductCard product={productData} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

);

export default ProductsList;



// WEBPACK FOOTER //
// ./src/components/products-list/index.js